import { ArrowRightOutlined, ShareAltOutlined } from '@ant-design/icons';
import { Button, Collapse, Divider, Input, Popconfirm, Spin } from 'antd';
import { useEffect, useState } from 'react';
import { t } from '../../languages';
import { ACTIVATE_TUTOR, PRODUCTS } from '../../modules/user';
import GoalOptions from '../DailyGoal/GoalOptions';
import BottomMenu from '../BottomMenu';
import Premium from '../Subscription/Premium';
import SubscriptionOptions from '../Subscription/SubscriptionOptions';
import ActivateTutor from '../TutorManager/ActivateTutor';
import SectionHeader from '../Utils/SectionHeader';
import SocialShare from '../Utils/SocialShare';
import AgeButtons from './AgeButtons';
import AvatarPicker from './AvatarPicker';
import LangButtons from './LangButtons';

const { Panel } = Collapse;

const ageRange = {
  1: '5-7',
  2: '8-11',
  3: '12 +',
};

const GreaterThan = () => {
  return <svg viewBox="64 64 896 896" focusable="false" data-icon="right" width="1em" height="1em" fill="currentColor" aria-hidden="true" data-darkreader-inline-fill=""><path d="M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"></path></svg>;
}

const UserProfile = ({ user, logout, lang, isApple, changeLanguage, deleteAccount, updateUserFields, isLoading, getUserData, theClass }) => {

  const currentClass = user ? user.currentClass : null;
  const children = user && user.isParent ? user.children : [];

  const [openConfirm, setOpenConfirm] = useState(false);
  const [newName, setNewName] = useState('');
  const [collapseOpen, setCollapseOpen] = useState(['0']);


  useEffect(() => {
    // console.log('UserProfile useEffect[]:', user);

    if (user) getUserData();
  }, []);


  useEffect(() => {
    // console.log('isLoading effect...', isLoading);
    if (isLoading) setCollapseOpen(['0']);
  }, [isLoading]);


  const handleCollapse = (key) => {
    // console.log('handleCollapse...', collapseOpen, key);

    if (collapseOpen.join('') == key.join('')) setCollapseOpen(['0']);
    else setCollapseOpen(key);
  }

  const products = user ? user.products : null;
  const isCourse = products && (products.includes(PRODUCTS.COURSE));
  const isApp = (!products) || (products && products.includes(PRODUCTS.APP));
  const userIsStudent = user && user.joinedToClass || false;

  // console.log('UserProfile.render products, isCourse, isApp:', products, isCourse, isApp);

  return (
    <div className="profile user-profile">

      {isLoading ? <Spin size="large" className="spinner" /> : null}

      <div className="profile-body">
        <div className='mis-wrapper'>

          <SectionHeader section={'profile'} />

          <div className="my-data profile-data">
            <div>
              <AvatarPicker lang={lang} handleChange={(anV) => updateUserFields({ avatar: anV })} selected={user.avatar} />
            </div>
            <div className="my-data-data">
              <Collapse className='edit-name' activeKey={collapseOpen} onChange={() => handleCollapse(['1'])}>
                <Panel header={<h3 className="bold gamer-nick">{user ? user.name : null}</h3>} key="1" >
                  {userIsStudent ? null : <div className='name-form'>
                    <Input value={newName} onChange={(e) => setNewName(e.target.value)} placeholder={t(lang, 'changeyourname')} />
                    <button disabled={newName.length < 3} onClick={() => updateUserFields({ name: newName })}><ArrowRightOutlined /></button>
                  </div>}
                </Panel>
              </Collapse>
            </div>

            {userIsStudent ? null : <div className="my-data-data email"><h4>{user ? user.email : null}</h4></div>}

            {userIsStudent && theClass ? <div className="my-data-data class-data">
              <p>{t(lang, 'class')}: <strong>{theClass.name}</strong> <br />
                {t(lang, 'classcode')}: <strong>{theClass.code}</strong></p>
            </div> : null}
          </div>

          <div className="my-data">
            <h3 className="my-data-data">{t(lang, 'sharemis')} <ShareAltOutlined style={{ fontSize: "1.6em", margin: "3px 8px 0" }} /></h3>
            <div className="my-data-data"><SocialShare lang={lang} /></div>
          </div>

          {userIsStudent ? null : <div className="my-data"><h3 className="my-data-data">{t(lang, 'data')}</h3>

            {!isApp ? null : <div className='age my-data-data'>
              <h4>{t(lang, 'agelevel')}</h4> {user ? (
                <Collapse className='select-age' activeKey={collapseOpen} onChange={() => handleCollapse(['2'])}>
                  <Panel header={<div><img className="age_img" src={`./static/ages/age_${user.age}.svg`} /> {ageRange[user.age]}<Premium isClient={user.isClient} /></div>} key="2">
                    {user.isClient ? <AgeButtons age={user.age} handleChangeAge={(selAge) => updateUserFields({ age: selAge })} /> : null}
                  </Panel>
                </Collapse>
              ) : null}
            </div>}

            <div className='age my-data-data'>
              <h4>{t(lang, 'dailygoal')}</h4>
              <Collapse className='select-age' activeKey={collapseOpen} onChange={() => handleCollapse(['3'])}>
                <Panel header={<div>{user.dailyGoal} min. <Premium isClient={user.isClient} /></div>} key="3">
                  {user.isClient ? <GoalOptions dailyGoal={user.dailyGoal} handleGoalChange={(e) => updateUserFields({ dailyGoal: e.target.value })} /> : null}
                </Panel>
              </Collapse>
            </div>

            {!(isApp && ACTIVATE_TUTOR) ? null : <div className='age my-data-data'>
              <h4>{t(lang, 'Koyu')}</h4>
              <div>
                <span style={{ margin: "0 8px", fontSize: "12px" }}><GreaterThan /></span>
                <span><ActivateTutor isActive={user.tutor} canActive={user.isClient} handleChange={(val) => updateUserFields({ tutor: val })} /></span>
                <Premium isClient={user.isClient} />
              </div>
            </div>}

            {currentClass ? <h4 className="my-data-data">{'Clase'}: {currentClass}</h4> : null}
          </div>}

          <div className="my-data">
            <h3 className="my-data-data">{t(lang, 'language')}</h3>
            <LangButtons lang={lang} handleChangeLang={(selLang) => changeLanguage(selLang)} />
          </div>

          <Divider />
          <br />
          <br />

          {(!isApp || userIsStudent) ? null : <div className="logout"><SubscriptionOptions lang={'lang'} /></div>}

          <Divider />

          <div className="logout">
            <Button className="button-next" onClick={() => logout()}>{t(lang, 'logout')}</Button>
          </div>

          <hr />

          <br />
          <br />
          <br />


          <div className="logout">
            <Popconfirm
              title={t(lang, 'sureDeleteAccount')}
              onConfirm={() => { setOpenConfirm(false); deleteAccount(); }}
              onCancel={() => setOpenConfirm(false)}
              okText={t(lang, "yes")}
              cancelText={t(lang, "no")}
              open={openConfirm}
            >
              <Button danger ghost className="button-danger" onClick={() => setOpenConfirm(true)}>{t(lang, 'deleteAccount')}</Button>
            </Popconfirm>
          </div>

          <br />
          <br />


        </div>
      </div>

      <BottomMenu section={'profile'} />

    </div>
  );
};

export default UserProfile;
